import * as React from 'react';

interface IProps {
    id: string,
    rowValues: string[],
}

export default class InventoryRow extends React.Component<IProps, {}> {
    static propTypes = {
        id: React.PropTypes.string.isRequired,
        rowValues: React.PropTypes.array.isRequired,
    };

    render() {
        const { id, rowValues } = this.props;

        return (
            <tr key={id}>
                {rowValues.map((rowValue, colIndex) => {
                    return <td key={`${id}-${colIndex}`}>{rowValue}</td>
                })}
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/inventory/listInventory/InventoryRow.tsx